export default __webpack_public_path__ + "static/media/6.d43355d6.png";